import Vue from 'vue';
import VueScrollTo from 'vue-scrollto';
import InstantSearch from 'vue-instantsearch';
import App from './App.vue';

Vue.use(InstantSearch);
Vue.use(VueScrollTo);

export default (() => {
    const node = document.querySelector('#product-search');
    if (!node) return;

    new Vue({
        el: node,
        data: { ...node.dataset },
        render: (h) => h(App)
    });

})();
